export type API_Data_Free_Trial_Response = {
  id: string,
  creation_time: string,
  modification_time: string,
  autorenewing: boolean,
  user_id: string,
  product_id: string,
  product_name: string,
  source: string,
  free: boolean,
  subs_status: number,
  expired: boolean,
  start_time: string,
  expiration_time: string, 
  replaced: boolean,
  promotion_code: string,
  purchase_token: string,
  order_id: string,
  autoresume_time: null | string,
  profile_id: string,
  future_product_id: null | string
}


export type API_Data_CreateCheckout_Response = string

export enum FreeTrialErrorsTypes {
  USER_NOT_ELIGIBLE = 400,
  UNAUTHENTICATED = 401,
  SERVER_ERROR = 500
}